import { useEffect } from 'react';
import { Link } from 'react-router';
import BlogHeader from './BlogHeader.jsx';
import { useLocation } from 'react-router';
import flowerPlants from './images/flowerplants.png';
import mgeOrg from './images/mge-org.png';
import razsadiNet from './images/razsadi-net.png';
import handShake from './images/handshake copy.png';
import noBg from './images/Untitled-nobg.png';
import esteta from './images/esteta_logo.png';
import toiletCubicles from './images/toilet_cubicles.png';
import blueBreeze from './images/bluebreeze.png';
import blueBreezeScreen from './images/bluebreezeScreen.png';
import sacp from './images/sacp_logo.png';
import sacpSite from './images/sacp_site.png';
import avmLogo from './images/avm-logo.png';
import avmHome from './images/avm-home.png';
import vitLogo from './images/vit-logo.png';
import vitHome from './images/vit-home.png';
import petkovaLogo from './images/petkova-logo.png';
import petkovaHome from './images/petkova-home.png';

function BlogPage() {

    const location = useLocation();
    const blogPageTitles = [
        {
            name: '/blog/e-shop-flower-plants',
            value: 'E-магазин за цветя и растения',
            content: '<p>Новият електронен магазин, който завършихме е специализиран в продажбата на всякакви цветя, растения, разсади, плодни храсти, луковици и други подходящи за всеки дом и градина.</p><p> Разширяваме успешното ни партньорство с Оакплантс 78 ЕООД.</p><p> След групата онлайн магазини базирани на <b>OpenCart</b> пуснахме в екслоатация и нов базиран на <b>WordPress и WooCommerce</b>.</p><p> С удовлетворение и с чувство на добре свършен ангажимент приключихме изграждането на онлайн магазина и го пуснахме в действие. </p><p> По желание на клиента внедрихме два метода за плащане - <b> с наложен платен или директно плащане онлайн с карта. </b></p><p><b>Индивидуалният подход при изграждането всеки сайт тип е-магазин</b> гарантира максимално ефективното използване на всички налични ресурси съобразени с конкретната специфика на работата и дейността на фирмата поръчител. </p>',
            contentBottom: '<p style="padding-top: 20px;">От съществено значение за бързодействието на систeмата е <b>оптимизирането на базата от данни</b> и правилното разпределение на ресурсите.</p>',
            date: '26.09.2025',
            icon: flowerPlants,
            image: flowerPlants,
            link: 'https://flowerplants.eu/'
        },
        {
            name: '/blog/crm-sistemata-na-max-group-events',
            value: 'СРМ системата на Max Group Events',
            content: '<p style="padding-top: 20px;">Системата за управление на взаимоотношенията с клиентите <b>(CRM) е приложен софтуер за всякакви бизнес организации и фирми</b>, който управлява взаимодействието с настоящи и бъдещи клиенти.</p><p>В днешното време на силна конкуренция бизнесът все повече разчита на CRM системите за <b>спечелване на нови клиенти</b> и за улесняване на комуникацията и взаимоотношенията с тях. </p><p>Приехме като предизвикателство поръчката на нашите партньори от <b>Max Group Events</b> да направим CRM система специфична за техните нужди и организация на работа. </p><p> С удовлетворение и с чувство на добре свършен ангажимент приключихме изграждането на системата на първия етап и я пуснахме в експлоатация. </p><p><b>Индивидуалният подход при изграждането  на СРМ система</b> гарантира максимално ефективното използване на всички налични ресурси съобразени с конкретната специфика на работата и дейността на фирмата поръчител. <b>Оптимално извършената дигитализация</b> на процесите в една организация от своя страна гарантира бизнес успех. Води до освобождаване на време, възможност за увеличаване на приходите, спестяване на човешкия ресурс и възможност за пренасочването му към други дейности.  </p>',
            contentBottom: '<p style="padding-top: 20px;">От съществено значение за бързодействието на систeмата е <b>оптимизирането на базата от данни</b> и правилното разпределение на ресурсите.</p><p>Приложениeтo на CRM системaтa обхваща управлението на контакти с клиенти, централизиране на информацията от различни канали, проследяване на сделките и поддръжка. Те позволяват на фирмите да съберат на <b>едно място данни за комуникацията, поръчките и бележките от и към клиентите</b>, предоставяйки им цялостен поглед върху всеки клиент и неговата история. </p>',
            date: '08.09.2025',
            icon: handShake,
            image: mgeOrg,
            link: 'https://maxgroupevents.org/'
        },
        {
            name: '/blog/onlain-magazini-za-razsadi-rasteniq-i-ovoshtni-durveta',
            value: 'Онлайн магазини за разсади, растения и овощни дървета',
            content: '<p className="blog-paragraph">Изградихме успешно партньорство с <b>Оакплантс 78 ЕООД</b>.</p><p>Изграждането и поддържането на <b>групата е-магазини на фирмата</b> е наш постоянен ангажимент, който изпълняваме с удоволствие.</p><p>С помощта на изработената от нас <b>функционалност за импорт и експорт</b> на данните на продукти и категории по лесен и безпроблемен начин става добавянето на множество нови продукти и категории от други партньорски сайтове както и възможността за интегриране на продуктите на нашия клиент от други онлайн магазини.</p><p><b>От съществено значение за бързодействието</b> на системата е оптимизирането на базата от данни и правилното СЕО управление. </p>',
            contentBottom: '<p className="blog-paragraph">Групата е-магазини на Оакплантс 78 ЕООД, които поддържаме, <b>представлява 4 отделни специализирани сайтове </b> за различни типове разсади, растения или овощни дървета.</p><p>Работата с <b>динамично променяща се база от данни</b> в зависимост от сезона или дори от месеца  на налични продукти и категории обуславя и допълнителното внедраване на различни <b>авоматизирани процеси при управление на е-магазините</b>. Това неминуемо спестява много време на служителите и улеснява техния работен процес и продажби.  </p>',
            date: '05.08.2025',
            icon: noBg,
            image: razsadiNet,
            link: 'https://www.razsadi.net/'
        },
        {
            name: '/blog/esteta-design-pregradni-steni-wc-kabini',
            value: 'Сайт за преградни стени и wc кабини на Естета Дизайн',
            content: '<p className="blog-paragraph">Изградихме успешно партньорство с <b>Естета Дизайн ЕООД</b>.</p><p>Изграждането и поддържането на сайта на фирмата е наш постоянен ангажимент, който изпълняваме с удоволствие.</p><p><b>От съществено значение за бързодействието</b> на системата е оптимизирането на базата от данни и правилното СЕО управление. </p>',
            contentBottom: '<p className="blog-paragraph">Естета Дизайн е млада и иновативна компания, специализирана в проектирането и изработката на WC кабини, писоарни прегради, душ кабини и различни типове преградни системи от HPL плоскости. </p>',
            date: '20.11.2025',
            icon: esteta,
            image: toiletCubicles,
            link: 'https://toilet-cubicles.bg'
        },
        {
            name: '/blog/erp-sistemata-na-max-group-events',
            value: 'ERP системата на Max Group Event',
            content: '<p className="blog-paragraph">(ERP - Enterprise Resource Planning, Планиране на ресурсите на предприятието) е <b>интегриран софтуер, който обединява и автоматизира основните бизнес процеси</b> (финанси, производство, човешки ресурси, продажби, логистика) на една компания в единна система с обща база данни. </p>',
            contentBottom: '<p className="blog-paragraph">Продължаваме нашето сътрудничество с Max Group Event и след като преди няколко месеца изградихме тяхната CRM система сега разширихме специализирания софтуерен продукт адаптиран и съобразен с техните конкретни нужди и характеристики. </p>',
            date: '15.12.2025',
            icon: handShake,
            image: mgeOrg,
            link: 'https://maxgroupevents.org/'
        },
        {
            name: '/blog/sacp',
            value: 'Нов сайт на Държавната агенция за закрила на детето',
            content: '<p className="blog-paragraph">Пуснахме в експлоатация новия сайт на <b>Държавната агенция за закрила на детето (ДАЗД)</b>.</p><p>Порталът е модернизиран, оптимизиран и представящ дейността  на агенцията по достъпен и удобен за гражданите начин. </p>',
            contentBottom: '<p className="blog-paragraph">Така поставихме началото на нашето сътрудничество с агенцията като иновативния и професионален подход и гарантиране качеството на продукта си остава наш постоянен ангажимент.  </p>',
            date: '07.01.2026',
            icon: sacp,
            image: sacpSite,
            link: 'https://sacp.government.bg'
        },
        {
            name: '/blog/bluebreeze-travel',
            value: 'Сайт на туристическа агенция Блу Брийз Травъл',
            content: '<p className="blog-paragraph">Изградихме и пуснахме в екслоатация сайта на туристическата компания <b>Блу Брийз Травъл</b>.</p><p>Тук потребителите могат да разгледат и изберат за своята ваканция измежду <b>интересни и вълнуващи оферти за пътешествия</b>.</p> </p>',
            contentBottom: '<p className="blog-paragraph">Правилното СЕО управление ще гарантира успешното позициониране на сайта и страниците с офертите в глобалната мрежа. </p> <p>Блу Брийз Травел е туристическа компания родена от спонтанната идея за пътешествия в компания на други пътешественици по душа.</p> <p>Собственичката Боряна като малка доста време е живяла в Близкия Изток, след което със започване на работа в различни компании е продължила да пътешества, много пъти съвсем сама. Така тя посещава 50+ държави, а в някои пътува повече от един път- Италия, Мексико, Ямайка, Сащ, Бали, Украйна, Турция и много други. </p>',
            date: '29.01.2026',
            icon: blueBreeze,
            image: blueBreezeScreen,
            link: 'https://bluebreeze-travel.com'
        },
        {
            name: '/blog/martina-petkova',
            value: 'Правен съветник по недвижими имоти Мартина Петкова',
            content: '<p className="blog-paragraph">Поддържаме сайта на <b>Мартина Петкова</b>, която е <b>юрист и икономист</b>. </p>',
            contentBottom: '<p className="blog-paragraph">Нейната дейност е специализирана в <b>правните съвети по недвижими имоти</b> и надеждната юридическа превенция при покупката им. </p><p> Като специалист с над 20 годишен опит с голяма експертиза Мартина съдейства и за отпускането на кредити при възможно най-добрите условия за клиентите си, както и за разрешаването на евентуални по-сложни <b>юридически казуси свързани със собствеността на имотите</b>. </p>',
            date: '20.02.2026',
            icon: petkovaLogo,
            image: petkovaHome,
            link: 'https://petkova.bg'
        },
        {
            name: '/blog/vit',
            value: 'ВИТ - борсата за матраци',
            content: '<p className="blog-paragraph">В е-магазина на <b>ВИТ – Борсата за матраци</b> предлагаме разнообразие от <b>над 800 матраци</b>. </p>',
            contentBottom: '<p className="blog-paragraph">Компанията е създадена през 1996 г. и за първи път в България представя водещите марки матраци на едно място. Днес ВИТ – Борсата за матраци има <b>10 работещи франчайз обекта</b> в страната. </p><p>ВИТ олицетворява класическия принцип на франчайзинг идеята – духът на семеен бизнес, разпределен в множество малки обекти. Партнират си с хора с предприемачески дух и желание за развитие</p>',
            date: '25.03.2026',
            icon: vitLogo,
            image: vitHome,
            link: 'https://vit.bg'
        },
        {
            name: '/blog/avm-consult',
            value: 'Организационна система на счетоводна къща АВМ Консултинг Груп',
            content: '<p className="blog-paragraph"><p><b>АВМ Консултинг Груп ООД</b> е счетоводна къща, която предоставя счетоводни услуги, данъчни и бизнес консултации и виртуален офис на малки, средни и големи предприятия.</p> </p>',
            contentBottom: '<p className="blog-paragraph"> <p>Създадохме интегриран софтуер, който автоматизира основни бизнес процеси използвани от компанията. По този начин <b>дейности вършени преди за часове или дни вече се осъщестяват за минути.</b> </p> </p>',
            date: '28.04.2026',
            icon: avmLogo,
            image: avmHome,
            link: 'https://avm.vekotasoft.com'
        }
    ];

    let currentBlog = {
        name: '',
        value: 'Блог',
        content: '',
        contentBottom: '',
        date: '',
        icon: handShake,
        image: '',
        link: ''

    };
    currentBlog = blogPageTitles.find(obj => obj.name === location.pathname) ||  currentBlog;

    useEffect(() => {
        window.scrollTo({
                top: 0,
                behavior: "smooth",
            })
    }, []);

  return (
    <>
        <BlogHeader />
        <section className="blog blog-section" id="about-us">
            <div className="container">
                <div className="title text-center">
                    <h1 className="title-blue blog-title">
                        {currentBlog.value}     
                    </h1>
                </div>
                <div className="container-services">
                    <div className="row">
                        <div className="col-sm-12 col-lg-12">
                            <div className="media aos-init aos-animate" data-aos="fade-up" data-aos-delay="200" data-aos-duration="400">
                                <Link to={currentBlog.link} target="_blank">
                                    <img className="mr-4" src={currentBlog.icon} alt="" />
                                </Link>
                                <div className="media-body">
                                    <h5 className="blog-2">{currentBlog.date}</h5>
                                    <span className="blog-content">
                                        <div className="content" dangerouslySetInnerHTML={{__html: currentBlog.content}}></div>
                                        <Link to={currentBlog.link} target="_blank">
                                            <img className="blog-img" src={currentBlog.image} alt="" />
                                        </Link>
                                        <div className="content" dangerouslySetInnerHTML={{__html: currentBlog.contentBottom}}></div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  );
}

export default BlogPage;
